"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReceiptChargingSessionAttemptsSerialization = void 0;
const ChargingSessionAttemptSerialization_1 = require("./ChargingSessionAttemptSerialization");
class ReceiptChargingSessionAttemptsSerialization {
    static serialize(entity) {
        const copy = { ...entity };
        copy.receipt_transactions = entity.receipt_transactions?.map((field) => field
            ? JSON.parse(ChargingSessionAttemptSerialization_1.ChargingSessionAttemptSerialization.serialize(field))
            : undefined);
        return JSON.stringify(copy);
    }
    static deserialize(msg) {
        const entity = JSON.parse(msg);
        const copy = { ...entity };
        copy.receipt_transactions = entity.receipt_transactions?.map((field) => field
            ? ChargingSessionAttemptSerialization_1.ChargingSessionAttemptSerialization.deserialize(JSON.stringify(field))
            : undefined);
        return copy;
    }
}
exports.ReceiptChargingSessionAttemptsSerialization = ReceiptChargingSessionAttemptsSerialization;
